<template>
	<span v-if="resolvedToken">{{ resolvedToken }}</span>
</template>

<script setup lang="ts">
import { DatetimeFormat, SanityRichTextInterpolationToken, SanityRichTextTokenContext } from 'types/sanity';
import { computed } from 'vue';
import { CustomSpacetimeFormat } from 'types/spacetime-formats';
import spacetime from 'spacetime';

interface Props {
	token: SanityRichTextInterpolationToken;
	context: SanityRichTextTokenContext;
}

const props = defineProps<Props>();

function formatDate(date: string, format: DatetimeFormat): string {
	switch (format) {
		case 'yyyy':
			return spacetime(date).format(CustomSpacetimeFormat.YEAR);
		case 'MMMM d, yyyy':
			return spacetime(date).format(CustomSpacetimeFormat.MONTH_DATE_PAD_YEAR);
		case 'MM/dd/yyyy': {
			return spacetime(date).format(CustomSpacetimeFormat.NUMERIC_US);
		}
		case 'MMMM yyyy':
			return spacetime(date).format(CustomSpacetimeFormat.MONTH_YEAR);
	}
}

// this is pretty barebones for now, but we will expand it as more use cases ie other interpolation tokens come in to play
const resolvedToken = computed((): string => {
	const { token, tokenType, tokenFormat } = props.token;

	const valueFromContext = props.context[token];
	if (!valueFromContext) return '';

	switch (tokenType) {
		case 'DATETIME': {
			const date = props.context[token];
			return formatDate(date ?? '', tokenFormat);
		}
		case 'STRING':
			return valueFromContext;
		// Map other tokens here as needed as such
		// case 'CURRENCY': {
		// 	const amount = props.context[token];
		// 	return currency(amount);
		// }
		default:
			return token;
	}
});
</script>
